var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMuteVideoEveryoneElse = function SvgMuteVideoEveryoneElse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m3.136 7.1 14.448 14.447-1.033 1.032-2.598-2.599a.936.936 0 0 1-.459.153H3.709a.786.786 0 0 1-.803-.804V11.15c0-.459.344-.803.803-.803h.612L2.104 8.131 3.136 7.1zm14.448 3.669v8.714l-9.135-9.134h5.045c.459 0 .84.344.84.803v2.866l3.25-3.249zM14.688.818l8.164 8.165-.584.583L20.8 8.098a.536.536 0 0 1-.26.086h-5.528a.444.444 0 0 1-.454-.454V3.108c0-.26.195-.454.454-.454h.345l-1.253-1.253.584-.583zm8.164 2.074v4.924L17.69 2.654h2.851c.26 0 .476.194.476.454v1.619l1.835-1.835z"
  })));
};

export default SvgMuteVideoEveryoneElse;